import {
    fork,
    put,
    take,
    takeLatest,
    delay
} from "redux-saga/effects";
import {
    sagaActionTypes,
    updateCountriesTreeData
} from "../actions/lightningAction";
import {
    getReportDatas,
} from "@/util/http/Quantis";
import { getCountriesTree } from "@/util/http/Lightning";
import localforage from "localforage";



function *fetchCountriesData(action){
    try{
        console.log("fff action ",action.payload);
        const {countries} = action.payload;
        const res = yield getCountriesTree(countries);
        localforage.setItem("country", JSON.stringify(res?.data));
        yield put(updateCountriesTreeData(res.data));

    }
    catch(error){
        console.log("current countrycdoe have error",error);
    }
}

function *rootSaga() {
    yield takeLatest(sagaActionTypes.SAGA_UPDATE_COUNTRESTREEDATA,fetchCountriesData);
}

export default rootSaga;